import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import { pageSize } from "../../../components/PaginationPageSize";
import pdfMake from "pdfmake/build/pdfmake";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import Pagination from "pages/Pagination/Pagination";
import Code from "components/SmallComponents/Code";
// import { ref } from "yup";

const QualityInwardControlList = forwardRef((porps, ref) => {
  const [orders, setOrders] = useState([]);
  const [unique, setunique] = useState([]);
  const gridRef = useRef();
  sessionStorage.setItem("tab", "Sales");
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const data = useRef([]);

  const [loading, setLoading] = useState(true); // State for loading indicator
  const obj_from_parant = porps.obj;
  const searchParameter2 = porps.searchParameter2;

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 46 && item.view
  );

  //for paggination fuctionallity...

  const [count, setCount] = useState();
  const pageSizeInput = [{ size: 20 }, { size: 50 }, { size: 100 }];
  const [recordPerPage, setRecordPerPage] = useState(pageSize);
  const totalPages = count / recordPerPage;
  const roundedTotalPages = Math.ceil(totalPages);
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();

  const options = pageSizeInput.map((resstate) => ({
    label: resstate.size,
    value: resstate.size,
  }));
  const defaultOption = options.find((option) => option.value === pageSize);

  useEffect(() => {
    if (searchParameter2 !== "") {
      obj_from_parant.search_parameter = searchParameter2;
    }
    fetchData();
  }, [
    page,
    recordPerPage,
    obj_from_parant.search_company_specific_criteria_id,
    obj_from_parant.search_company_specific_date_range_id,
    obj_from_parant.search_parameter,
    searchParameter2,
  ]);

  const obj = {
    search_company_specific_criteria_id:
      obj_from_parant.search_company_specific_criteria_id !== undefined
        ? obj_from_parant.search_company_specific_criteria_id
        : "",
    search_company_specific_date_range_id:
      obj_from_parant.search_company_specific_date_range_id !== undefined
        ? obj_from_parant.search_company_specific_date_range_id
        : "",
    search_parameter:
      obj_from_parant.search_parameter !== undefined
        ? obj_from_parant.search_parameter
        : "",
  };

  const fetchData = () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    var limit = recordPerPage;

    const requestPayload = {
      ...obj, // Include other properties from obj
      offset,
      limit,
    };

    axios
      .post(
        "/api/purple-fusion/qualityinward/get/companypurchaseorder/qualitycheck",
        requestPayload,
        { ...headers, timeout: 20000 }
      )
      .then((res) => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setunique(res.data);
          setCount(res.data[0].count);
          console.log(res.data);
          data.current = res.data.slice().sort((a, b) => b.id - a.id);
          setOrders(res.data);
        } else {
          console.log(res.data);
          setunique([]);
          setCount(0);
          data.current = [];
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log("Error in featcheing data", e);
      });
  };

  const sortedItems = unique.slice().sort((a, b) => b.id - a.id);

  useImperativeHandle(
    ref,
    () => ({
      downloadExcel: () => {
        onBtnExport();
      },

      downloadPdf: () => {
        DownloadPDF();
      },
    }),
    []
  );

  const DownloadPDF = () => {
    const docDefinition = {
      pageOrientation: "portrait",
      header: {
        text: " Waiting for Inward List",
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "Sr.NO", style: "tableHeader", bold: true }],
                [{ text: "CODE", style: "tableHeader", bold: true }],
                [
                  {
                    text: "SUPPLIER INVOICE",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [
                  {
                    text: "SUPPLIER NAME",
                    style: "tableHeader",
                    bold: true,
                  },
                ],

                [{ text: "CREATED DATE", style: "tableHeader", bold: true }],
              ],
              ...sortedItems?.map((item, index) => [
                index + 1,
                item.code,
                item.supplier_invoice,
                item.supplier_name,
                item.createdon.substr(0, 10),
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 12,
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "#000",
        },
        header: {
          fontSize: 15,
          bold: true,
          margin: [10, 10, 20, 0],
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download(" Waiting for Inward List");
  };

  const onBtnExport = useCallback(() => {
    const options = {
      fileName: "WaitingForQuality.csv",
    };

    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const [colDefs, setColDefs] = useState([
    { headerName: "Sr.No", field: "sr", width: 100 },
    {
      headerName: "SUPPLIER NAME",
      field: "supplier_name",
      width: 180,
    },
    {
      headerName: "CODE",
      field: "code",
      width: 220,
      cellRenderer: (params) => <Code>{params.value}</Code>,
    },
    {
      headerName: "SUPPLIER INVOICE",
      field: "supplier_invoice",
      width: 190,
    },
    {
      headerName: "DELIVERY CHALLAN",
      field: "supplier_delivery_challan",
      width: 190,
    },
    {
      headerName: "P.O TYPE",
      field: "company_purchase_order_type_name",
      width: 190,
    },

    {
      headerName: "ACTIVE",
      field: "isactive",
      valueFormatter: (params) => (params.value ? "Yes" : "No"),
      width: 110,
    },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
      width: 120,
    },
    {
      headerName: "ACTION",
      filter: false,
      field: "id",
      width: 130,
      pinned: "right",
      cellRenderer: (params) => (
        <button
          className="px-3 py-1 text-sm font-medium border-2 border-blue-500 rounded hover:bg-blue-500 hover:text-white-A700 transition duration-200"
          onClick={() => {
            navigate(
              `/companypurchesorderentry/edit/check/all/${params.data.company_purchase_order_id}`,
              {
                state: {
                  company_purchase_order_id:
                    params.data.company_purchase_order_id,
                  quality: true,
                  supplier_invoice: params.data.supplier_invoice,
                  supplier_delivery_challan: params.data.supplier_delivery_challan,
                  code: params.data.code,
                },
              }
            );
            sessionStorage.setItem("code1", params.data.code);
          }}
        >
          Accept All
        </button>
      ),
    },
  ]);

  const ColDefaultVale = { filter: true };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= roundedTotalPages) {
      setPage(newPage);
    } else if (newPage < 1) {
      setPage(1);
    } else if (newPage > roundedTotalPages) {
      setPage(roundedTotalPages);
    }
  };

  const decrementCount = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const incrementCount = () => {
    if (page < roundedTotalPages) {
      setPage(page + 1);
    }
  };
  //CustomeStyle of Ag Grid...
  const customeStyle = { height: 400, width: "100%", fontSize: "12px" };

  return (
    <>
      {showActionColumn ? (
        <div>
          <div
            className="ag-theme-quartz"
            // style={{ height: 550  ,width:"100%",fontSize:'12px' }}
            id="tab-grid-table"
            // style={customeStyle}
          >
            <AgGridReact
              ref={gridRef}
              rowData={sortedItems.map((orders, index) => ({
                ...orders,
                sr: index + (offsetforSR + 1),
              }))}
              columnDefs={colDefs}
              // pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              // gridOptions={gridOptions}
              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
            />
          </div>
          <div>
            <Pagination
              count={count}
              setRecordPerPage={setRecordPerPage}
              recordPerPage={recordPerPage}
              setLoading={setLoading}
              setData={setunique}
              setPage={setPage}
              page={page}
            />
          </div>

          {/* pagination.... */}
          {/* <div className="flex items-center justify-end space-x-4 mt-6 mr-3">
            <test className="text-sm text-gray-700">Page Size</test>

            <Select
              options={options}
              className="bg-white-A700 border border-gray-200_02 border-solid h-3 rounded-[5px] w-25 mb-7"
              menuPlacement="top"
              defaultValue={defaultOption} // Set the default selected option
              onChange={(selectedOption) => {
                setRecordPerPage(selectedOption.value);
                setPage(1);
              }}
            />
            <button onClick={decrementCount} disabled={page === 1}>
              <IoIosArrowBack className="inline-block align-middle cursor-pointer" />
            </button>

            <div className="flex items-center space-x-2">
              <span className="text-gray-700 text-sm">Page</span>
              <input
                type="number"
                min="1"
                max={roundedTotalPages}
                value={page}
                onChange={(e) => setPage(parseInt(e.target.value))}
                onBlur={() => handlePageChange(page)}
                className="appearance-none block w-16 px-3 py-2 border border-gray-300 rounded-md leading-tight focus:outline-none focus:border-blue-500 text-center"
              />
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-gray-700 text-sm ">of</span>
              <input
                type="number"
                value={roundedTotalPages}
                className="appearance-none block w-16 px-3 py-2 border border-gray-300 rounded-md leading-tight focus:outline-none focus:border-blue-500 text-center"
              />
            </div>
            <button
              //  className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
              onClick={incrementCount}
            >
              <IoIosArrowForward className="inline-block align-middle" />
            </button>
          </div> */}
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
});

export default QualityInwardControlList;
